import React, { useEffect, useRef, useState } from "react"
import { Container } from "reactstrap"
import { useParams } from "react-router-dom"
import JsPDF from "jspdf"
import { Row, Modal, Form } from "reactstrap"

// canvas
import SignatureCanvas from "react-signature-canvas"

// images
import zithasLogo from "../../assets/images/zithas-dark-logo.png"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import configure from "configure"
import Swal from "sweetalert2"
import html2pdf from "html2pdf.js"
import { useReactToPrint } from "react-to-print"
import { onDownloadPdf } from "utils/common-helpers"

const GenerateLinkLetters = () => {
  const [fixedRightSec, setFixedRightSec] = useState(false)
  const [modal_center, setmodal_center] = useState(false)
  const [attachmentModal, setAttachmentModal] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 48) {
      setFixedRightSec(true)
    } else {
      setFixedRightSec(false)
    }
  })

  const contentRef = useRef(null)
  const reactToPrintFn = useReactToPrint({
    contentRef,
    documentTitle: "Letter",
    removeAfterPrint: true,
  })

  function addNoBreakInline(html) {
    // Make paragraphs / lists / divs avoid breaks
    html = html
      .replace(
        /<p([^>]*)>/g,
        `<p$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 20px">`
      )
      .replace(
        /<li([^>]*)>/g,
        `<li$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px">`
      )
      .replace(
        /<ol([^>]*)>/g,
        `<ol$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px">`
      )
      .replace(
        /<ul([^>]*)>/g,
        `<ul$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px">`
      )
      .replace(
        /<div([^>]*)>/g,
        `<div$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      )
      .replace(
        /<h([1-5])([^>]*)>/g,
        `<h$1$2 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      )

    html = html.replace(
      /<table([^>]*)>/g,
      `<div style="page-break-inside: avoid; break-inside: avoid; padding-top: 5px;"><table$1>`
    )

    html = html.replace(/<\/table>/g, `</table></div>`)

    return html
  }

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "Letter",
    removeAfterPrint: true,
    pageStyle: `
    @page { 
      size: A4; 
      margin: 0.5in; 
    }
    @media print {
      body { -webkit-print-color-adjust: exact; }
      #printableLetter {
        padding: 40px 70px !important;
      }
      .text-center img {
        height: 80px !important;
      }
    }
  `,
  })
  const params = useParams()
  const [isLoading, setLoading] = useState(false)
  const [description, setDescription] = useState("")
  const [date, setDate] = useState("")
  const [expire, setExpire] = useState()
  const [attachment, setAttachment] = useState("")

  useEffect(() => {
    fetchContract()
  }, [])

  const fetchContract = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("junk_link", params.id)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/showStaffLetter`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        if (
          response?.data?.success == true &&
          response?.data?.data?.signature == null
        ) {
          setExpire(false)
          const htmlRaw = response?.data?.data?.final_template
          let cleanHTML = htmlRaw.replaceAll("{", "").replaceAll("}", "")
          const processed = addNoBreakInline(cleanHTML)
          setDescription(processed)
          setDate(response.data?.data?.created_at)
          setLetterId(response.data.data.staff_letter_id)
          setLetterType(response.data.data.LetterTemplate)
        } else {
          setLetterType(response?.data?.data?.LetterTemplate)
          setExpire(true)
        }
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [letter_id, setLetterId] = useState("")
  const [letterType, setLetterType] = useState("")

  const signatureRef = useRef(null)

  const handleSave = async e => {
    e.preventDefault()
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      Swal.fire({
        icon: "warning",
        text: "Please Sign the letter",
      })
      return
    }
    const signatureImage = signatureRef.current.toDataURL()
    setLoading(true)
    const formData = new FormData()
    formData.append("letter_id", letter_id)
    formData.append("name", name)
    formData.append("email", email)
    formData.append("signature", signatureImage)
    try {
      console.log("calling api")
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/signLetter`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      console.log("api called: ", response)
      console.log(response)
      if (response.data.success == true) {
        console.log("response", response)
        Swal.fire({
          icon: "success",
          text: `Thanks For signing ${letterType}`,
        }).then(data => {
          setmodal_center(false)
          window.location.reload()
        })
      } else {
        console.log(response)
        Swal.fire({
          icon: "warning",
          text: "Please Enter Same Name and Email Address",
        }).then(data => {})
      }

      setLoading(false)
    } catch (err) {
      setLoading(false)
      Swal.fire({
        icon: "warning",
        text: "Please Enter Same Name and Email Address",
      }).then(data => {})
    }
  }
  const handleClear = () => {
    signatureRef.current.clear()
  }

  const handleAttachmentSave = async e => {
    e.preventDefault()
    if (attachment?.length > 0) {
      try {
        setLoading(true)
        const formData = new FormData()
        formData.append("letter_id", letter_id)
        formData.append("name", name)
        formData.append("email", email)
        formData.append("signature", attachment)

        const response = await axios.post(
          `${configure.apiUrl}/contract/save_contract`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        )
        setLoading(false)
        if (response.data.success == true) {
          Swal.fire("", "Thanks For signining Letter", "success")
          setName("")
          setEmail("")
          setAttachmentModal(false)
        }
      } catch (error) {
        console.log(error)
        setLoading(false)
        Swal.fire("", "Something went wrong!", "error")
      }
    }
  }

  const handleToBase24 = e => {
    if (
      e.target.files[0].type == "image/jpeg" ||
      e.target.files[0].type == "image/png"
    ) {
      const image_data = new FileReader()
      image_data.addEventListener("load", () => {
        setAttachment(image_data.result)
      })
      image_data.readAsDataURL(e.target.files[0])
    } else {
      Swal.fire("", "Only JPG and PNG images can upload!", "warning")
    }
  }

  if (expire == false) {
    return (
      <React.Fragment>
        {isLoading && <Loader />}
        <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
          <Container fluid>
            <Row>
              <div className="col-md-9 col-12 ps-md-0 order-md-1 order-2 mt-4">
                <div
                  className="bg-white shadow document"
                  ref={contentRef}
                  id="printableLetter"
                  style={{
                    paddingLeft: "120px",
                    paddingRight: "120px",
                    paddingTop: "30px",
                    paddingBottom: "50px",
                  }}
                >
                  <div
                    className="text-center"
                    style={{ marginBottom: "20px", paddingTop: "20px" }}
                  >
                    <img
                      src={zithasLogo}
                      height="80"
                      alt="zithasLogo"
                      style={{ maxHeight: "80px" }}
                    />
                  </div>
                  <div>
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: description
                            .replaceAll("{", "")
                            .replaceAll("}", ""),
                        }}
                      />
                    </div>

                    <h5 className="fw-bold text-decoration-underline">
                      Date : {moment(date).format("DD-MM-YYYY")}
                    </h5>

                    <Row className="mt-4 justify-space-between">
                      <div className="col-md-4">
                        <div className="sign-box">Signature</div>
                      </div>
                    </Row>
                  </div>
                </div>
              </div>

              <div className="col-md-3 col-12 pe-md-0 order-md-2 order-1 mb-md-0 mb-3 mt-4">
                <div
                  className={`${
                    fixedRightSec ? "fixed-right-section top-0 " : ""
                  }`}
                >
                  {/* buttons */}
                  <div className="col-12 text-xl-start text-center">
                    <button
                      onClick={() => handlePrint()}
                      className="btn btn-sm btn-success border-radius me-1"
                    >
                      <i className="fas fa-print me-1"></i> Print
                    </button>
                    <button
                      onClick={() => setmodal_center(true)}
                      className="btn btn-sm btn-primary border-radius me-1"
                    >
                      <i className="fas fa-file-signature me-1"></i> Signature
                    </button>

                    <button
                      onClick={() => onDownloadPdf(setLoading, contentRef, letterType)}
                      className="btn btn-sm btn-secondary border-radius"
                    >
                      <i className="fas fa-file-download me-1"></i> Downloads
                    </button>
                  </div>
                </div>
              </div>
            </Row>
          </Container>
        </div>

        <Modal
          isOpen={modal_center}
          toggle={() => {
            tog_center()
          }}
          centered
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              Signature & Confirmation Of Identity
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_center(false)
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSave}>
              <Row>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control "
                    onChange={e => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">Personal Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">Signature</label>
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      className: "sigCanvas border w-100 signatureHeight",
                    }}
                    ref={signatureRef}
                  />
                </div>
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <a className="btn btn-red btn-label me-2" onClick={handleClear}>
                  <i className="bi bi-x-circle label-icon"></i>
                  Clear Signature
                </a>
                <button className="btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
        <Modal isOpen={attachmentModal} centered size="md">
          <div className="modal-header">
            <h5 className="modal-title mt-0">Attach Your Signature</h5>
            <button
              type="button"
              onClick={() => {
                setAttachmentModal(false)
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleAttachmentSave}>
              <Row>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control"
                    onChange={e => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">Signature Attachment</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleToBase24}
                  />
                </div>

                {attachment && (
                  <div>
                    <img src={attachment} alt="" height={"80px"} />
                  </div>
                )}
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <button className="btn btn-save btn-label" type="submit">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </React.Fragment>
    )
  } else if (expire == true) {
    return (
      <section className="my-5 pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center col">
              <div className="home-wrapper">
                <div className="mb-5">
                  <a
                    className="d-block auth-logo"
                    href={`${configure.appUrl}dashboard`}
                  ></a>
                </div>
                <div className="justify-content-center row">
                  <div className="col-sm-4">
                    <div className="maintenance-img">
                      <img
                        src="/static/media/maintenance.938d28ce46a03edf5d9303e67f1d2028.svg"
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <img src={zithasLogo} className="" height="100" />
                </div>
                <h1 className="pt-5">Thanks For signing {letterType}</h1>
                <h5 className="mt-2">We'll get in contact with you shortly </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return <Loader />
  }
}

export default GenerateLinkLetters
